import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconComboChartAxis: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconComboChartAxis"><Path d="M5 9.375L7.90039 7.2002L8.26758 6.92383L12.8701 7.94629L19.4473 4.6582L20.3418 6.44727L13.4473 9.89453L13.1299 10.0527L12.7832 9.97656L8.73047 9.0752L5.09961 11.7998L5 11.874V19H21V21H3V3H5V9.375Z" fill="currentColor"/><Path d="M9 18H7V12H9V18Z" fill="currentColor"/><Path d="M14 18H12V13H14V18Z" fill="currentColor"/><Path d="M19 18H17V11H19V18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconComboChartAxis;
